import { Api } from '../api/Api.js'

export function apiGetKalas() {
  return Api('get', '/fm/get_kalas')
}
